import { API_ENDPOINTS } from "../../config/api.js";
import { makeApiRequest } from "../apiClient.js";
import { appendFrontendApiLog } from "../../utils/frontendApiLogger.js";

export const userUseCaseService = {
  getUseCaseData: async (data) => {
    try {
      appendFrontendApiLog("userUseCase.getUseCaseData.request", { data });
      const response = await makeApiRequest({
        endpoint: API_ENDPOINTS.USER_USECASE_DATA,
        method: "POST",
        data,
        accessToken: localStorage.getItem("accessToken"),
      });
      appendFrontendApiLog("userUseCase.getUseCaseData.response", {
        data,
        response: response.data,
      });
      return response.data;
    } catch (error) {
      appendFrontendApiLog("userUseCase.getUseCaseData.error", {
        data,
        error: error?.message || String(error),
      });
      throw error;
    }
  },

  getById: async (data) => {
    try {
      appendFrontendApiLog("userUseCase.getById.request", { data });
      const response = await makeApiRequest({
        endpoint: API_ENDPOINTS.USER_USECASE_GET_BY_ID,
        method: "POST",
        data,
        accessToken: localStorage.getItem("accessToken"),
      });
      appendFrontendApiLog("userUseCase.getById.response", {
        data,
        response: response.data,
      });
      return response.data;
    } catch (error) {
      appendFrontendApiLog("userUseCase.getById.error", {
        data,
        error: error?.message || String(error),
      });
      throw error;
    }
  },

  getUseCaseListForUser: async (data) => {
    try {
      appendFrontendApiLog("userUseCase.getUseCaseListForUser.request", { data });
      const response = await makeApiRequest({
        endpoint: API_ENDPOINTS.USER_USECASE_LIST_FOR_USER,
        method: "POST",
        data,
        accessToken: localStorage.getItem("accessToken"),
      });
      appendFrontendApiLog("userUseCase.getUseCaseListForUser.response", {
        data,
        response: response.data,
      });
      return response.data;
    } catch (error) {
      appendFrontendApiLog("userUseCase.getUseCaseListForUser.error", {
        data,
        error: error?.message || String(error),
      });
      throw error;
    }
  },

  insert: async (data) => {
    try {
      appendFrontendApiLog("userUseCase.insert.request", { data });
      const response = await makeApiRequest({
        endpoint: API_ENDPOINTS.USER_USECASE_INSERT,
        method: "POST",
        data,
        accessToken: localStorage.getItem("accessToken"),
      });
      appendFrontendApiLog("userUseCase.insert.response", {
        data,
        response: response.data,
      });
      return response.data;
    } catch (error) {
      appendFrontendApiLog("userUseCase.insert.error", {
        data,
        error: error?.message || String(error),
      });
      throw error;
    }
  },

  update: async (data) => {
    try {
      appendFrontendApiLog("userUseCase.update.request", { data });
      const response = await makeApiRequest({
        endpoint: API_ENDPOINTS.USER_USECASE_UPDATE,
        method: "POST",
        data,
        accessToken: localStorage.getItem("accessToken"),
      });
      appendFrontendApiLog("userUseCase.update.response", {
        data,
        response: response.data,
      });
      return response.data;
    } catch (error) {
      appendFrontendApiLog("userUseCase.update.error", {
        data,
        error: error?.message || String(error),
      });
      throw error;
    }
  },

  delete: async (data) => {
    try {
      appendFrontendApiLog("userUseCase.delete.request", { data });
      const response = await makeApiRequest({
        endpoint: API_ENDPOINTS.USER_USECASE_DELETE,
        method: "POST",
        data,
        accessToken: localStorage.getItem("accessToken"),
      });
      appendFrontendApiLog("userUseCase.delete.response", {
        data,
        response: response.data,
      });
      return response.data;
    } catch (error) {
      appendFrontendApiLog("userUseCase.delete.error", {
        data,
        error: error?.message || String(error),
      });
      throw error;
    }
  },
};

